import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import Logo from "@/components/Logo";
import { scrollState } from "@/lib/scrollState";

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const { scrollY, scrollYProgress } = useScroll();

    useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 40));

    const toTop = () => {
        if (scrollState.lenis) scrollState.lenis.scrollTo(0, { duration: 1.6 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <header
            className={`fixed inset-x-0 top-0 z-30 transition-colors duration-500 ${
                scrolled
                    ? "border-b border-line bg-cream/80 backdrop-blur-md"
                    : "border-b border-transparent"
            }`}
        >
            <div className="flex items-center justify-between px-6 py-4 lg:px-14">
                <button
                    data-testid="nav-brand-logo"
                    onClick={toTop}
                    className="group flex items-center gap-2.5"
                >
                    <Logo className="h-7 w-7 transition-transform duration-500 group-hover:rotate-180" />
                    <span className="font-display text-lg font-semibold tracking-tight text-ink">
                        Roots <span className="italic text-terracotta">&amp;</span> Routes
                    </span>
                </button>
                <p className="hidden font-mono text-[11px] uppercase tracking-[0.28em] text-inksoft md:block">
                    A journey in seven chapters
                </p>
            </div>
            <motion.div
                data-testid="scroll-progress-bar"
                style={{ scaleX: scrollYProgress }}
                className="h-[2px] origin-left bg-terracotta"
            />
        </header>
    );
};

export default Navbar;
